module.exports = __webpack_public_path__ + "static/media/logo_branca.55f42b43.png";